import { DEFAULT_ENTITY_TYPE } from '@potato-golem/ui'

export const EntityTypeRegistry = {
  DEFAULT: DEFAULT_ENTITY_TYPE,
  CARD: 'card',
}
